<template>
	<span v-if="label && label.message" class="app-label" :class="label?.type">
		{{ label.message }}
	</span>
</template>

<script lang="ts" setup>
import type { MessageLabel } from "@/models/MessageLabel";

defineProps<{
	label: MessageLabel;
}>();
</script>

<style lang="scss">
.app-label {
	&.error {
		color: var(--color-fail);
	}

	&.warning {
		color: var(--color-warn);
	}

	&.success {
		color: var(--color-success);
	}

	&.neutral {
		color: var(--accent-primary);
	}
}
</style>
